import {TICKET_LATLNG} from './ticketTypes'

export const changepositionTicket = positionTicket => {
    return {
        type: TICKET_LATLNG,
        load: positionTicket
    }
}

export const selectNewTicketPosition = (positionTicket) => {

    return (dispatch) => {
        dispatch(changepositionTicket(positionTicket))
    }

}